import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import context from './context.js';

const dropdownGroupHeaderClasses = ({ isOpen } = {}) => _.compact([
  'particles-dropdown__group-header',
  !isOpen && 'particles-dropdown__group-header--closed',
  isOpen && 'particles-dropdown__group-header--open'
]).join(' ');
const DropdownGroupHeader = ({ children, as: Component, ...rest }) => {
  const { isOpen } = React.useContext(context.dropdownState);
  if (!isOpen) {
    return null;
  }
  return (
    <Component {...rest} className={dropdownGroupHeaderClasses({ isOpen })}>
      {children}
    </Component>
  );
};
DropdownGroupHeader.displayName = 'Dropdown.GroupHeader';
DropdownGroupHeader.defaultProps = { as: 'span' };
DropdownGroupHeader.propTypes = {
  /** Render as this kind of component */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]),
  /** Child components */
  children: PropTypes.node,
  /** Additional class to add to component */
  className: PropTypes.string
};

export default DropdownGroupHeader;
